import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class VanityHandle extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_handle';
    this.partName = 'Handle';
    this.translateId = "visualizer.bathroom.vanity.vanity_handle";
    this.dbName = "Vanity Handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityHandle())
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getArrayOfConditions() {
    const counterTopSize = this.getParent().counterTopSize();
    return [{
      propName: 'VanitySize',
      propValue: counterTopSize
    }];
  }

  getAvailableFeatures() {
    return this.features && this.features.filter(f => f.matchesMetaForCondition('VanitySize', this.getParent().counterTopSize())) || [];
  }

  setDefault(layout) {
    const filteredFeatures = this.getAvailableFeatures();
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Aliveri");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setLayers(layout) {

    const vanityPedestal = this.getParent().pedestalSink;
    if (vanityPedestal && vanityPedestal.activeFeature) {
      const handleMeta =  vanityPedestal.activeFeature.metaData["VanityHandle"];
      const hardCodedWizardConditions = vanityPedestal.activeFeature.partName.includes("WizardPlaceholder") &&
        (
          vanityPedestal.activeFeature.partName.includes("WizardPlaceholder52 in36 S")
          || (handleMeta && handleMeta.includes("true"))  // WizardPlaceholder QC Liberty
        );
      if (handleMeta && handleMeta.includes("None") || hardCodedWizardConditions) {
        super.hideLayers();
        return;
      }
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      const zIndex = zIndexes.Vanity.Custom.Handle;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
